import { connect } from 'react-redux'
import StepsIndicator from '../../components/services/edit/ServiceCreateStepsIndicator'
import { IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState) => {
  return {
    steps: state.serviceEdit.steps.list,
    currentStep: state.serviceEdit.steps.currentStep
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StepsIndicator)



// WEBPACK FOOTER //
// ./src/containers/services/StepsIndicator.ts